/** @jsxImportSource @emotion/react */
import React, { useState, useEffect, useMemo, useCallback, memo } from 'react';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component

import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
import { ColDef, ValueFormatterParams, GridReadyEvent } from 'ag-grid-community';
import { CommonYN } from 'models/common/Common';
import { AllInputWrap, CustomInputText, CustomInputWrap } from 'components/inputs/CustomInput';

import { getApprovalRuleMasters, setApprovalRuleMaster } from 'apis/admin/ApprovalRule';
import { ApprovalRuleMaster } from 'models/admin/Approval';
import { ApproveExcludeDetail, ApproveExcludeMaster } from 'models/admin/ApproveExclude';
import { getAllApproveExcludeDetails, getAllApproveExcludeList } from 'apis/admin/ApproveExclude';
import { getCommonCodeNames } from 'apis/admin/CommonCode';
import { Code } from 'models/common/CommonCode';
import { useCommonModal } from 'hooks/useCommonModal';
import { useTranslation } from 'react-i18next';
import { Button, FormControl } from '@mui/material';

import { getNotificationGroupUsers, getNotificationGroups } from 'apis/admin/Notification';
import { NotificationGroup, NotificationGroupUser } from 'models/admin/Notification';

import {
  ControlBtnGroup,
  GlobalBtnGroup,
  SubTitleGroup,
  SubTitleLayout,
} from '../../../components/layouts/ContentLayout';
import { IconButton } from '../../../components/buttons/IconSVG';
import TableContainer from '@mui/material/TableContainer';
import { tb } from '../../../components/layouts/Table';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import CustomInputWithSearch from '../../../components/inputs/CustomInputWithSearch';
import { ComboBox } from '../../../components/selects/ComboBox';
import CustomGrid from '../../../components/grids/CustomGrid';

interface SearchParamData {
  sRuleId: string;
  callBackFunc?: () => void;
}

const ApprovalMasterForm = (props: SearchParamData) => {
  const { openCommonModal } = useCommonModal();
  const { t } = useTranslation();

  const [rowDataExc, setRowDataExc] = useState<ApproveExcludeDetail[]>([]);
  const [rowDataNtdk, setRowDataNtdk] = useState<NotificationGroupUser[]>([]);

  const [formRuleId, setFormRuleId] = useState<string>('');
  const [formRuleNm, setFormRuleNm] = useState<string>('');
  const [formLnAddPmitYn, setFormLnAddPmitYn] = useState<string>('');
  const [formRferAddPsblYn, setFormRferAddPsblYn] = useState<string>('');
  const [formLnRstbPmitYn, setFormLnRstbPmitYn] = useState<string>('');
  const [formLnDuplPmitYn, setFormLnDuplPmitYn] = useState<string>('');
  const [formExcId, setFormExcId] = useState<string>('');
  const [formNtdkId, setFormNtdkId] = useState<string>('');

  const [excList, setExcList] = useState<ApproveExcludeMaster[]>([]);
  const [ntdkList, setNtdkList] = useState<NotificationGroup[]>([]);

  const [code, setCode] = useState<any>();
  const [errors, setErrors] = useState<any>({});

  const data = {
    aprRuleId: formRuleId,
    aprRuleNm: formRuleNm,
    aprLnAddPmitYn: formLnAddPmitYn,
    aprRferAddPsblYn: formRferAddPsblYn,
    aprLnRstbPmitYn: formLnRstbPmitYn,
    aprLnDuplPmitYn: formLnDuplPmitYn,
    aprExcTgtId: formExcId,
    mstNtdkId: formNtdkId,
  } as ApprovalRuleMaster;

  const onInitialized = (grid) => {
    grid.hostElement.addEventListener('click', (e) => {
      if (grid.rows.length == 0) return;
      const ht = grid.hitTest(e);
      if (ht.row < 0 || ht.col < 0) return;
      const item = grid.rows[ht.row].dataItem;
      // -
    });
  };

  const excColumnDefs: ColDef[] = useMemo(
    () => [
      {
        header: String(t('com.label.NO', 'NO')),
        binding: 'crudKey',
        width: 100,
        align: 'center',
        cellTemplate: (grid) => grid.row._idx + 1,
      },
      {
        header: String(t('admin.grid.제외구분', '제외구분')),
        binding: 'aprExcDivsCd',
        width: 150,
        align: 'center',
        cellTemplate: (grid) => {
          console.log(grid);
          // return code?.divisionCode
          //   .map((node) => {
          //     return node.cmnCd == grid.value && node.cmnCdNm;
          //   })
          //   .filter((e) => e != false)[0] as string;
        },
      },
      {
        header: String(t('admin.grid.제외대상', '제외대상')),
        binding: 'aprExcUserId',
        cellTemplate: (grid) => {
          // return grid.data.aprExcUserInfo;
          // // 아래 switch는 무효코드
          // switch (grid.data.aprExcDivsCd) {
          //   case 'JPS':
          //     return code?.jpsCode
          //       .map((node) => {
          //         return node.cmnCd == grid.value && node.cmnCdNm;
          //       })
          //       .filter((e) => e != false)[0] as string;
          //   case 'JTI':
          //     return code?.jtiCode
          //       .map((node) => {
          //         return node.cmnCd == grid.value && node.cmnCdNm;
          //       })
          //       .filter((e) => e != false)[0] as string;
          //   default:
          //     return grid.data.aprExcUserInfo;
          // }
        },
      },
    ],
    [code]
  );

  const ntdkColumnDefs: ColDef[] = useMemo(
    () => [
      {
        header: String(t('com.label.NO', 'NO')),
        binding: 'crudKey',
        width: 100,
        align: 'center',
        cellTemplate: (grid) => grid.row._idx + 1,
      },
      {
        header: String(t('com.label.아이디', '아이디')),
        width: 120,
        binding: 'aprNotfUserId',
        align: 'center',
      },
      {
        header: String(t('admin.grid.이름', '이름')),
        width: 120,
        binding: 'empNm',
        align: 'center',
      },
      {
        header: String(t('admin.grid.직책/직급호칭', '직책/직급호칭')),
        binding: 'jtiNm',
        width: 150,
        align: 'center',
      },
      {
        header: String(t('admin.grid.부서', '부서')),
        binding: 'deptNm',
      },
    ],
    []
  );

  const fnSearchApprovalMaster = useCallback((param: string) => {
    if (param)
      getApprovalRuleMasters(param, '').then((result: ApprovalRuleMaster[]) => {
        fnSetResultData(result[0]);
      });
    else fnFormInit(false);
  }, []);

  const [editable, setEditable] = useState<boolean>(false);

  const fnFormInit = (edit: boolean) => {
    setFormRuleId('');
    setFormRuleNm('');
    setFormLnAddPmitYn(CommonYN.Y);
    setFormRferAddPsblYn(CommonYN.Y);
    setFormLnRstbPmitYn(CommonYN.Y);
    setFormLnDuplPmitYn(CommonYN.Y);
    setFormExcId('');
    setFormNtdkId('');
    setRowDataExc([]);
    setRowDataNtdk([]);
    setEditable(edit);
    props.callBackFunc && props.callBackFunc();
  };

  const fnSetResultData = (result: ApprovalRuleMaster) => {
    setFormRuleId(result.aprRuleId);
    setFormRuleNm(result.aprRuleNm);
    setFormLnAddPmitYn(result.aprLnAddPmitYn);
    setFormRferAddPsblYn(result.aprRferAddPsblYn);
    setFormLnRstbPmitYn(result.aprLnRstbPmitYn);
    setFormLnDuplPmitYn(result.aprLnDuplPmitYn);
    setFormExcId(result.aprExcTgtId || '');
    fnGetExcList(result.aprExcTgtId || '');
    setFormNtdkId(result.mstNtdkId || '');
    fnGetNtdkList(result.mstNtdkId || '');
    setEditable(true);
  };

  const fnGetExcList = (excId: string) => {
    getAllApproveExcludeDetails(excId).then((result: ApproveExcludeDetail[]) => {
      setRowDataExc(result);
    });
  };
  const fnGetNtdkList = (ntdkId: string) => {
    if (ntdkId === '') {
      setRowDataNtdk([]);
    } else {
      getNotificationGroupUsers({ ntdkId: ntdkId }).then((result: NotificationGroupUser[]) => {
        setRowDataNtdk(result);
      });
    }
  };

  const getCommonCodesForGrid = async () => {
    const divisionCodeRes: Code[] = await getCommonCodeNames('APR_EXC_DIVS_CD');
    const jpsCodeRes: Code[] = await getCommonCodeNames('JPS_CD');
    const jtiCodeREs: Code[] = await getCommonCodeNames('JTI_CD');
    const useYn: Code[] = await getCommonCodeNames('YN_FLAG');

    const excListResult = await getAllApproveExcludeList('');
    console.log('결재제외 목록 : ', excListResult);
    const excList = excListResult.map((i) => ({
      cmnCd: i.aprExcTgtId,
      cmnCdNm: i.aprExcNm,
    }));
    const notificationGroups = await getNotificationGroups({ useYn: CommonYN.Y });
    const notificationList = notificationGroups.map((i) => ({
      cmnCd: i.ntdkId,
      cmnCdNm: i.ntdkNm,
    }));

    setCode({
      divisionCode: divisionCodeRes,
      jpsCode: jpsCodeRes,
      jtiCode: jtiCodeREs,
      useYn: useYn,
      excList: excList,
      ntdkList: notificationList,
    });
  };

  const btnSave = () => {
    //Validation Start
    if (!data.aprRuleNm)
      return openCommonModal({
        content: t('admin.msg.결재규칙명을 입력하세요.', '결재규칙명을 입력하세요.'),
      });
    //아래는 화면상 구현 불가능한 validation. console 등을 통해서만 구현 가능.
    if (!data.aprLnAddPmitYn)
      return openCommonModal({
        content: t(
          'admin.msg.Please enter an item: aprLnAddPmitYn',
          'Please enter an item: aprLnAddPmitYn'
        ),
      });
    if (!data.aprLnDuplPmitYn)
      return openCommonModal({
        content: t(
          'admin.msg.Please enter an item: aprLnDuplPmitYn',
          'Please enter an item: aprLnDuplPmitYn'
        ),
      });
    if (!data.aprLnRstbPmitYn)
      return openCommonModal({
        content: t(
          'admin.msg.Please enter an item: aprLnRstbPmitYn',
          'Please enter an item: aprLnRstbPmitYn'
        ),
      });
    if (!data.aprRferAddPsblYn)
      return openCommonModal({
        content: t(
          'admin.msg.Please enter an item: aprRferAddPsblYn',
          'Please enter an item: aprRferAddPsblYn'
        ),
      });
    //Validation End

    openCommonModal({
      modalType: 'confirm',
      content: t('com.label.저장하시겠습니까?', '저장하시겠습니까?'),
      noCallback: () => {
        return;
      },
    });

    setApprovalRuleMaster(data).then((result) => {
      if (result.successOrNot === 'N') {
        openCommonModal({
          content: ('statusCode: ' + result.statusCode + '\nmessage: ' + result.data) as string,
        });
        return false;
      }
      openCommonModal({
        content: t('com.label.저장되었습니다.', '저장되었습니다.'),
      });
      fnSearchApprovalMaster(props.sRuleId);
      props.callBackFunc && props.callBackFunc();
    });
  };

  useEffect(() => {
    fnSearchApprovalMaster(props.sRuleId);
  }, [props]);

  useEffect(() => {
    getCommonCodesForGrid();
  }, []);

  return (
    <>
      <SubTitleLayout>
        <SubTitleGroup>
          <h3>{t('admin.label.결재라인 기본정보', '결재라인 기본정보')}</h3>
        </SubTitleGroup>
        <ControlBtnGroup>
          <Button
            css={IconButton.button}
            className="write"
            disableRipple
            onClick={() => {
              fnFormInit(true);
            }}
          >
            {t('com.button.신규', '신규')}
          </Button>
        </ControlBtnGroup>
      </SubTitleLayout>
      <TableContainer css={tb.table} className="colFix4">
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <label>{t('admin.label.결재규칙ID', '결재규칙ID')}</label>
              </TableCell>
              <TableCell>
                <AllInputWrap>
                  <CustomInputWithSearch readOnly={true} value={formRuleId} />
                </AllInputWrap>
              </TableCell>
              <TableCell>
                <label>{t('admin.label.결재규칙명', '결재규칙명')}</label>
              </TableCell>
              <TableCell colSpan={3}>
                <AllInputWrap>
                  <CustomInputWrap>
                    <CustomInputText
                      value={formRuleNm}
                      onChange={(e) => {
                        editable && setFormRuleNm(e.target.value);
                      }}
                    />
                  </CustomInputWrap>
                </AllInputWrap>
              </TableCell>
            </TableRow>
            {/*<TableRow>*/}
            {/*  <TableCell>*/}
            {/*    <label>{t('admin.label.결재라인 추가허용', '결재라인 추가허용')}</label>*/}
            {/*  </TableCell>*/}
            {/*  <TableCell>*/}
            {/*    <ComboBox*/}
            {/*      options={code?.useYn}*/}
            {/*      defaultValue={formLnAddPmitYn}*/}
            {/*      placeholder={String(t('admin.label.선택', '선택'))}*/}
            {/*      onChange={(e) => editable && setFormLnAddPmitYn(e)}*/}
            {/*    />*/}
            {/*  </TableCell>*/}
            {/*  <TableCell>*/}
            {/*    <label>{t('admin.label.통보자 추가허용', '통보자 추가허용')}</label>*/}
            {/*  </TableCell>*/}
            {/*  <TableCell>*/}
            {/*    <ComboBox*/}
            {/*      options={code?.useYn}*/}
            {/*      defaultValue={formRferAddPsblYn}*/}
            {/*      placeholder={String(t('admin.label.선택', '선택'))}*/}
            {/*      onChange={(e) => editable && setFormRferAddPsblYn(e)}*/}
            {/*    />*/}
            {/*  </TableCell>*/}
            {/*  <TableCell>*/}
            {/*    <label>{t('admin.label.결재라인 재설정 허용', '결재라인 재설정 허용')}</label>*/}
            {/*  </TableCell>*/}
            {/*  <TableCell>*/}
            {/*    <ComboBox*/}
            {/*      options={code?.useYn}*/}
            {/*      defaultValue={formLnRstbPmitYn}*/}
            {/*      placeholder={String(t('admin.label.선택', '선택'))}*/}
            {/*      onChange={(e) => editable && setFormLnRstbPmitYn(e)}*/}
            {/*    />*/}
            {/*  </TableCell>*/}
            {/*</TableRow>*/}
            {/*<TableRow>*/}
            {/*<TableCell>*/}
            {/*  <label>{t('admin.label.결재제외', '결재제외')}</label>*/}
            {/*</TableCell>*/}
            {/*<TableCell>*/}
            {/*  <ComboBox*/}
            {/*    options={code?.excList}*/}
            {/*    defaultValue={formExcId}*/}
            {/*    placeholder={String(t('admin.label.사용안함', '사용안함'))}*/}
            {/*    onChange={(e) => {*/}
            {/*      editable && setFormExcId(e);*/}
            {/*      editable && fnGetExcList(e);*/}
            {/*    }}*/}
            {/*  />*/}
            {/*</TableCell>*/}

            {/*<TableCell colSpan={4} className="noBg BL">*/}
            {/*  <CustomGrid*/}
            {/*    layoutDefinition={excColumnDefs}*/}
            {/*    initialized={onInitialized}*/}
            {/*    isSelector={false}*/}
            {/*    rowData={rowDataExc}*/}
            {/*    height={140} // re size*/}
            {/*    deferResizing={false}*/}
            {/*    isReadOnly={true}*/}
            {/*    align={'center'}*/}
            {/*  />*/}
            {/*</TableCell>*/}
            {/*</TableRow>*/}
            <TableRow>
              <TableCell>
                <label>{t('admin.label.통보처', '통보처')}</label>
              </TableCell>
              <TableCell>
                <ComboBox
                  options={code?.ntdkList}
                  defaultValue={formNtdkId}
                  placeholder={String(t('admin.label.사용안함', '사용안함'))}
                  onChange={(e) => {
                    editable && setFormNtdkId(e);
                    editable && fnGetNtdkList(e);
                  }}
                />
              </TableCell>
              <TableCell colSpan={4} className="noBg BL">
                <CustomGrid
                  layoutDefinition={ntdkColumnDefs}
                  initialized={onInitialized}
                  isSelector={false}
                  rowData={rowDataNtdk}
                  height={150}
                  deferResizing={false}
                  isReadOnly={true}
                  isFilter={false}
                  allowPinning={false}
                  align={'center'}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <GlobalBtnGroup>
        <Button css={IconButton.button} className="save" disableRipple onClick={btnSave}>
          {t('com.button.저장', '저장')}
        </Button>
      </GlobalBtnGroup>
    </>
  );
};

export default memo(ApprovalMasterForm);
